import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type PerksCategoriesWithExpenseRequest = {
  perkCategoryId: number
  productClassId: string
}

export const deleteFuturePerk = (request: PerksCategoriesWithExpenseRequest): Promise<number> => {
  return adminHttpClient.delete(`/AdminDashboard/Perks/DeleteFuturePerk`, { data: request })
}
